import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { gql } from '@nerdwallet/apollo';
import { Type } from '@nerdwallet/currency';
import { setTrk, TrkElement, TrkPageType, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
import { getLegacyId, getMatchScore } from '@nerdwallet/marketplace/selectors/credit-cards';
import classes from '@nerdwallet/base-styles/classes';
import MatchScoreRing from './match-score-ring';
import MatchScoreTooltip, { GraphqlMatchScoreToolTip } from './match-score-tooltip';
import styles from "../marketplace-product-card.module.css";
import ketoStyles from "../keto-product-card/keto-product-card.module.css";
var GOOD_MATCH_SCORE_RANGE_START = 70;
var MATCH_SCORE_CTA_TEXT = 'Your NerdWallet';
var MATCH_SCORE_CTA_TEXT_COLOR = 'neutral-darker';

/**
 * @param {number} matchScore
 * @returns {Object}
 * {
 *     matchScoreColor: <color> {string}
 *
 * }
 */
var getMatchScoreRingDetails = function getMatchScoreRingDetails(matchScore) {
  return {
    matchScoreColor: matchScore >= GOOD_MATCH_SCORE_RANGE_START ? 'green' : 'yellow',
    matchScoreRingColor: matchScore >= GOOD_MATCH_SCORE_RANGE_START ? 'green-lightest' : 'yellow-lightest'
  };
};
var BaseMatchScoreCTA = function BaseMatchScoreCTA(_ref) {
  var _classNames;
  var isKetoCard = _ref.isKetoCard,
    matchScore = _ref.matchScore,
    legacyId = _ref.legacyId,
    taxonomy = _ref.taxonomy,
    tooltip = _ref.tooltip;
  var handleClick = useCallback(function () {
    var _setTrk;
    if (typeof window === 'undefined') {
      return;
    }
    window.location = setTrk((_setTrk = {
      url: "/recommend?matchScoreCTACardId=".concat(legacyId),
      taxonomy: taxonomy
    }, _defineProperty(_setTrk, TrkTag.element, TrkElement.button), _defineProperty(_setTrk, TrkTag.location, "match-score-cta--prodId".concat(legacyId)), _defineProperty(_setTrk, TrkTag.pageType, TrkPageType.marketPlace), _setTrk));
  }, [legacyId, taxonomy]);

  // If match score does not exist, don't render Match Score CTA
  if (!matchScore) {
    return null;
  }
  var _getMatchScoreRingDet = getMatchScoreRingDetails(matchScore),
    matchScoreColor = _getMatchScoreRingDet.matchScoreColor,
    matchScoreRingColor = _getMatchScoreRingDet.matchScoreRingColor;
  var matchScoreIcon = /*#__PURE__*/React.createElement(MatchScoreRing, {
    matchScore: matchScore,
    matchScoreColor: matchScoreColor,
    matchScoreRingColor: matchScoreRingColor,
    isKetoCard: isKetoCard
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames((_classNames = {}, _defineProperty(_classNames, ketoStyles.matchScoreCTAKeto, isKetoCard), _defineProperty(_classNames, styles.matchScoreCTA, !isKetoCard), _classNames))
  }, /*#__PURE__*/React.createElement("div", {
    className: classes('flex-direction-column', 'color-neutral-darker')
  }, /*#__PURE__*/React.createElement(Type, {
    color: MATCH_SCORE_CTA_TEXT_COLOR,
    onClick: handleClick,
    size: 1
  }, MATCH_SCORE_CTA_TEXT), /*#__PURE__*/React.createElement("div", {
    className: classes('display-inline-flex', 'margin-bottom-0')
  }, /*#__PURE__*/React.createElement(Type, {
    color: MATCH_SCORE_CTA_TEXT_COLOR,
    size: 1,
    className: classes('margin-right-1')
  }, "match score"), tooltip)), /*#__PURE__*/React.createElement("div", {
    className: classes('display-inline-flex', 'align-items-center'),
    onClick: handleClick,
    role: "presentation"
  }, isKetoCard ? [matchScoreIcon, /*#__PURE__*/React.createElement(Type, {
    className: classes('margin-left-2'),
    color: "blue",
    size: 3,
    key: "1"
  }, "".concat(matchScore, "%"))] : [/*#__PURE__*/React.createElement(Type, {
    className: classes('margin-right-2', 'margin-left-2'),
    color: matchScoreColor,
    key: "0"
  }, "".concat(matchScore, "%")), matchScoreIcon]));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  BaseMatchScoreCTA.propTypes = {
    isKetoCard: PropTypes.bool,
    legacyId: PropTypes.string,
    matchScore: PropTypes.number,
    taxonomy: PropTypes.objectOf(PropTypes.string),
    tooltip: PropTypes.node
  };
}
export var GraphqlMatchScoreCTA = function GraphqlMatchScoreCTA(_ref2) {
  var analytics = _ref2.analytics,
    approvalLikelihood = _ref2.approvalLikelihood,
    identity = _ref2.identity,
    isKetoCard = _ref2.isKetoCard,
    marketplaceEntity = _ref2.marketplaceEntity,
    taxonomy = _ref2.taxonomy;
  /*
   * @todo https://nerdwallet.atlassian.net/browse/RUR-532 to get the actual matchScore
   * Leaving this for now because the field will be defined in the styleguide but will be undefined
   * for the client.
   */
  var legacyId = marketplaceEntity.legacyId,
    matchScore = marketplaceEntity.matchScore;
  return /*#__PURE__*/React.createElement(BaseMatchScoreCTA, {
    isKetoCard: isKetoCard,
    legacyId: legacyId,
    matchScore: matchScore,
    taxonomy: taxonomy,
    tooltip: /*#__PURE__*/React.createElement(GraphqlMatchScoreToolTip, {
      analytics: analytics,
      approvalLikelihood: approvalLikelihood,
      identity: identity,
      marketplaceEntity: marketplaceEntity,
      taxonomy: taxonomy
    })
  });
};
GraphqlMatchScoreCTA.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment GraphqlMatchScoreCTA on MarketplaceEntityInterface {\n    ... on CreditCardsOfferV2 {\n      legacyId\n    }\n    ...GraphqlMatchScoreToolTip\n  }\n  ", "\n"])), GraphqlMatchScoreToolTip.fragment);
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');
  GraphqlMatchScoreCTA.propTypes = {
    analytics: _PropTypes.shape({
      entityName: _PropTypes.string
    }),
    approvalLikelihood: _PropTypes.number,
    identity: _PropTypes.oneOfType([_PropTypes.shape({
      vantageScore3: _PropTypes.number
    }), _PropTypes.shape({
      profiles: _PropTypes.shape({
        tu_credit_report_profile: _PropTypes.shape({
          vantage_score_3: _PropTypes.number
        })
      })
    })]),
    isKetoCard: _PropTypes.bool,
    marketplaceEntity: _PropTypes.shape({
      legacyId: _PropTypes.number,
      matchScore: _PropTypes.number
    }),
    taxonomy: _PropTypes.objectOf(_PropTypes.string)
  };
}
var MatchScoreCTA = function MatchScoreCTA(_ref3) {
  var analytics = _ref3.analytics,
    identity = _ref3.identity,
    isKetoCard = _ref3.isKetoCard,
    marketplaceEntity = _ref3.marketplaceEntity,
    taxonomy = _ref3.taxonomy;
  return /*#__PURE__*/React.createElement(BaseMatchScoreCTA, {
    isKetoCard: isKetoCard,
    legacyId: getLegacyId(marketplaceEntity),
    matchScore: getMatchScore(marketplaceEntity),
    taxonomy: taxonomy,
    tooltip: /*#__PURE__*/React.createElement(MatchScoreTooltip, {
      analytics: analytics,
      identity: identity,
      marketplaceEntity: marketplaceEntity,
      taxonomy: taxonomy
    })
  });
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes2 = require('prop-types');
  MatchScoreCTA.propTypes = {
    analytics: MatchScoreTooltip.propTypes.analytics,
    identity: _PropTypes2.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    marketplaceEntity: _PropTypes2.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    taxonomy: _PropTypes2.objectOf(_PropTypes2.string),
    isKetoCard: _PropTypes2.bool
  };
}
MatchScoreCTA.defaultProps = {
  taxonomy: {},
  isKetoCard: false
};
export default MatchScoreCTA;